module.exports = __webpack_public_path__ + "media/images/top/top/img_hero_sp-25b29f08693e9d6fb24e10fc6a787482.png";